import React, { Component } from 'react'
import { connect } from 'react-redux'

// Elements
import Overlay from '../../elements/overlay'

// Components
import OverlayHeader from '../../components/OverlayHeader'

import Task from '../../../pages/MyPage/MyTasks/Task'

import { translation } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'

import './taskoverlay.scss'

class TaskOverlay extends Component {
  renderHeader () {
    let task = this.props.task

    return (
      <OverlayHeader overlayId='TaskOverlay' onClose={this.props.onClose}>
        <div className='top topHeaderInfo'>
          <div className='heading'>
            <div className='heading-title'>{task.Title}</div>
            {window.innerWidth > 760 && <div className='heading-category'>{translation(task.Category)}</div>}
          </div>
          {window.innerWidth > 760 && (<div className='deadline'>
            <div className='deadline-title'>{translation(1232)}</div>
            <div className='deadline-date'>{renderFullDate(task.Deadline, false)}</div>
          </div>)}
        </div>
      </OverlayHeader>
    )
  }

  render () {
    let task = this.props.task
    if (typeof task !== 'object') return null
    return (
      <Overlay overlayId='TaskOverlay' extraClassName='task-overlay'>
        {this.renderHeader()}
        <div className='task-overlay__content'>
          <Task item={this.props.task} modal />
        </div>
      </Overlay>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { })(TaskOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/TaskOverlay/index.js